import { hasOwnProperty } from "@glideapps/ts-necessities";
import { checkString } from "../../Support";
import { localizedStringsGlobalInstance } from "./base";

export const localizedDevStrings = {};

export const intentionallyUntranslatedLocalizedDevStrings = {};

export type DevLanguageStrings = typeof localizedDevStrings & typeof intentionallyUntranslatedLocalizedDevStrings;
export type DevStringKey = keyof DevLanguageStrings;

export function getDevLocalizedString(name: DevStringKey): string {
    if (hasOwnProperty(localizedDevStrings, name)) {
        return localizedDevStrings[name] as string;
    }
    return (intentionallyUntranslatedLocalizedDevStrings as any)[name];
}

export function formatDevLocalizedString(name: DevStringKey, strings: ReadonlyArray<string>): string {
    return checkString(localizedStringsGlobalInstance().formatString(getDevLocalizedString(name), ...strings));
}

export function haveUnintentionallyUntranslatedStrings(): boolean {
    return Object.keys(localizedDevStrings).length > 0;
}
